import React from 'react'

export interface PlainTextRendererProps {
  content: string
  className?: string
}

/**
 * Simple plain text renderer with whitespace preservation
 *
 * Used for simple messages without markdown formatting
 */
export const PlainTextRenderer: React.FC<PlainTextRendererProps> = ({
  content,
  className = '',
}) => {
  return (
    <p className={`whitespace-pre-wrap text-sm font-normal ${className}`}>
      {content}
    </p>
  )
}
